import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgActionPending = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 100,
	height: 100,
	viewBox: "0 0 100 100",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("circle", {
			cx: 50,
			cy: 50,
			r: 50,
			fill: "#FFEDA5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M90.314 50.157C90.314 72.3351 72.3351 90.314 50.157 90.314C27.9789 90.314 10 72.3351 10 50.157C10 27.9789 27.9789 10 50.157 10C72.3351 10 90.314 27.9789 90.314 50.157Z",
			fill: "#FACC15"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 50.5,
			cy: 56.875,
			r: 1.875,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M50.4999 41.8749V51.2499M36.1148 64.375H64.8852C68.2085 64.375 70.3092 60.8936 68.6952 58.0608L54.31 32.8111C52.6494 29.8963 48.3506 29.8963 46.69 32.8111L32.3048 58.0608C30.6908 60.8936 32.7915 64.375 36.1148 64.375Z",
			stroke: "white",
			strokeWidth: 3,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgActionPending);
export default ForwardRef;
